import * as Yup from 'yup';
import checkoutFormModel from './formModel';

const moment = require('moment');

const {
    formField: {
        //POLIZA
        fechaEmision,
        frecuenciaPago,
        cuotas,
        ajusteAutomatico,
        vigenciaDesde,
        formaDePago,
        moduloCobertura,
        numeroTramite,
        numeroPoliza,
        numeroReferencia,
        premium,
        //CLIENTE
        cliente: {
            rol,
            sexo,
            fechaNacimiento,
            dni,
            cuit,
            telefono,
            codigoArea,
            domicilio,
            estadoCivil,
            apellido,
            codigosLocalidad,
            email,
            personaJuridica,
            actividadPrincipal,
            categoriaMonotributo,
            lugarNacimiento,
            nombre,
            situacionIva
        },
        emailDespachoElectronico,
        //VEHICULO
        vehiculo: {
            patente,
            chasis,
            motor,
            gnc: {
                valorTotal,
                cilindros : {
                    marcaCilindro,
                    numeroCilindro
                },
                marcaRegulador,
                numeroRegulador,
            },
            tieneGnc,
        },
        bienesAsegurados : {
            id,
            descripcion,
            suma
        }
    }
} = checkoutFormModel;
const fecha45dias = moment(moment().format('YYYY-MM-DD'), "YYYY-MM-DD").add(45, 'days')
const fecha30dias = moment().subtract(30,'d').format('YYYY-MM-DD');

function formatDate(date) {
    return new Date(date).toLocaleDateString()
}

export default [
    Yup.object().shape({
        //POLIZA
        [frecuenciaPago.name]: Yup.string().required(`${frecuenciaPago.requiredErrorMsg}`),
        [numeroPoliza.name]: Yup.number()
            .required(`${numeroPoliza.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [numeroTramite.name]: Yup.number()
            .required(`${numeroTramite.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [numeroReferencia.name]: Yup.number()
            .required(`${numeroReferencia.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [premium.name]: Yup.number()
            .required(`${premium.requiredErrorMsg}`)
            .integer()
            .typeError("Introduzca únicamente números"),
        [moduloCobertura.name]: Yup.string()
            .required(`${moduloCobertura.requiredErrorMsg}`),
        [fechaEmision.name]: Yup.date()
            .required(`${vigenciaDesde.requiredErrorMsg}`),
        [vigenciaDesde.name]: Yup.date()
            .required(`${vigenciaDesde.requiredErrorMsg}`)
            .min(fecha30dias, "La fecha no puede ser anterior a 30 días del día de la fecha")
            .max(fecha45dias, `La fecha no puede ser posterior a ${formatDate(fecha45dias)}`),
        [formaDePago.name]: Yup.string().required(`${formaDePago.requiredErrorMsg}`),
        [ajusteAutomatico.name]: Yup.string().when([frecuenciaPago.name], {
            is: '7',
            then: Yup.string().required(`${ajusteAutomatico.requiredErrorMsg}`)
        }),
        [cuotas.name]: Yup.string().when([frecuenciaPago.name], {
            is: '7',
            then: Yup.string().required(`${cuotas.requiredErrorMsg}`)
        }),
        //CLIENTE
        clientes: Yup.array().of(
            Yup.object().shape({
                [rol.name]: Yup.string().required(`${rol.requiredErrorMsg}`),
                [dni.name]: Yup.number()
                    .required(`${dni.requiredErrorMsg}`)
                    .min(1000000, "El documento ingresado no es válido")
                    .max(99999999, "El documento ingresado no es válido")
                    .integer()
                    .typeError("Introduzca únicamente números"),
                [cuit.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string()
                        .required(`${cuit.requiredErrorMsg}`)
                        .matches(/^(20|23|27|30|33)([0-9]{9}|-[0-9]{8}-[0-9]{1})$/, "El CUIT ingresado no es válido"),
                }),
                [nombre.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string()
                        .required(`${nombre.requiredErrorMsg}`)
                        .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
                        .max(40, "El nombre ingresado es muy largo"),
                }),
                [apellido.name]: Yup.string()
                    .required(`${apellido.requiredErrorMsg}`)
                    .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
                    .max(40, "El valor ingresado es muy largo"),
                [fechaNacimiento.name]: Yup.date().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.date()
                        .max(new Date(Date.now() - 567648000000), "El cliente debe tener al menos 18 años para contratar")
                        .required(`${fechaNacimiento.requiredErrorMsg}`),
                }),
                [estadoCivil.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string().required(`${estadoCivil.requiredErrorMsg}`),
                }),
                [sexo.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string().required(`${sexo.requiredErrorMsg}`),
                }),
                [domicilio.name]: Yup.string()
                    .required(`${domicilio.requiredErrorMsg}`)
                    .matches(/^[A-Za-z0-9 .-]+$/, "Esta utilizando carácteres no válidos"),
                [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
                [codigoArea.name]: Yup.number()
                    .required(`${codigoArea.requiredErrorMsg}`)
                    .integer()
                    .min(10, 'Introduzca un código de área valido')
                    .max(9999, 'Introduzca un código de área valido')
                    .typeError("Introduzca únicamente números")
                    .test(
                        'no-leading-zero',
                        'Por favor ingrese el código de área sin 0',
                        (value, context) => {
                            return context.originalValue && !context.originalValue.startsWith('0');
                        }
                    ),
                [telefono.name]: Yup.number()
                    .required(`${telefono.requiredErrorMsg}`)
                    .integer()
                    .min(100000, 'Introduzca un número de teléfono valido')
                    .max(99999999, 'Introduzca un número de teléfono valido')
                    .typeError("Introduzca únicamente números")
                    .test(
                        'no-leading-zero',
                        'Por favor introduzca su número sin el 15',
                        (value, context) => {
                            return context.originalValue && !context.originalValue.startsWith('15');
                        }
                    ),
                [email.name]: Yup.string()
                    .required(`${email.requiredErrorMsg}`)
                    .email("Ingrese un email válido"),
                [situacionIva.name]: Yup.string().required(`${situacionIva.requiredErrorMsg}`),
                [categoriaMonotributo.name]: Yup.string().required(`${categoriaMonotributo.requiredErrorMsg}`),
                [actividadPrincipal.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string().required(`${actividadPrincipal.requiredErrorMsg}`),
                }),
                [lugarNacimiento.name]: Yup.string().when([personaJuridica.name], {
                    is: '0',
                    then: Yup.string()
                        .required(`${lugarNacimiento.requiredErrorMsg}`)
                        .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                }),
            })
        ),
        //VEHICULO
        vehiculo: Yup.object().shape({
            [patente.name]: Yup.string()
                .required(`${patente.requiredErrorMsg}`)
                .matches(/^[a-zA-Z]{2,2}[0-9]{3,3}[a-zA-Z]{2,2}|[a-zA-Z]{3,3}[0-9]{3,3}$/, "La patente ingresada no es válida"),
            [motor.name]: Yup.string()
                .required(`${motor.requiredErrorMsg}`)
                .min(4, 'El número ingresado es muy corto')
                .max(20, "El número ingresado es muy largo"),
            [chasis.name]: Yup.string()
                .required(`${chasis.requiredErrorMsg}`)
                .min(4, 'El número ingresado es muy corto')
                .max(20, "El número ingresado es muy largo"),
            [tieneGnc.name]: Yup.string().required(`${tieneGnc.requiredErrorMsg}`),
            gnc: Yup.object().when([tieneGnc.name], {
                is: 'true',
                then: Yup.object().shape({
                    [marcaRegulador.name]: Yup.string()
                        .required(`${marcaRegulador.requiredErrorMsg}`)
                        .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                    [numeroRegulador.name]: Yup.string()
                        .required(`${numeroRegulador.requiredErrorMsg}`)
                        .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                    [valorTotal.name]: Yup.number()
                        .required(`${valorTotal.requiredErrorMsg}`)
                        .min(150000, "El monto mínimo es $150.000")
                        .max(2000000, "El monto máximo es $2.000.000"),
                    cilindros: Yup.array().of(
                        Yup.object().shape({
                            [marcaCilindro.name]: Yup.string()
                                .required(`${marcaCilindro.requiredErrorMsg}`)
                                .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                            [numeroCilindro.name]: Yup.string()
                                .required(`${numeroCilindro.requiredErrorMsg}`)
                                .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                        })
                    )
                })
            }),
        }),
        bienesAsegurados: Yup.array().of(
            Yup.object().shape({
                [id.name]: Yup.string().required(`${id.requiredErrorMsg}`),
                [descripcion.name]: Yup.string()
                    .required(`${descripcion.requiredErrorMsg}`)
                    .matches(/^([A-Za-z0-9 -]+)$/, "Esta utilizando carácteres no válidos"),
                [suma.name]: Yup.number()
                    .required(`${suma.requiredErrorMsg}`)
                    .min(10000, "El monto mínimo es $10.000")
                    .max(10000000, "El monto máximo es $10.000.000")
                    .typeError("El valor ingresado no es válido"),
            })
        ),
    }),
];
